import React from 'react';
import {
  Checkbox, Select, Upload, DatePicker, notification, Input, Button,
  Tooltip,
} from 'antd';
import {
  PlusOutlined, UploadOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import TenantActions from '@Actions/tenantActions';
import Constants, { toISTDate } from '@Apis/constants';
import './style.scss';
import TextArea from 'antd/es/input/TextArea';
import PRZSelect from '../../components/Common/UI/PRZSelect';

const { Option } = Select;
const dateFormat = 'DD/MM/YYYY';

const uploadButton = (
  <Button icon={<UploadOutlined />}>Upload</Button>
);

const uploadButtonForGRNLine = (
  <Button style={{ width: '150px' }} icon={<UploadOutlined />}>Click to Upload</Button>
);
/**
 * PareInput custom component
 *
 */
class H3CustomInput extends React.Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  /**
   *
   */
  componentDidMount() {

  }

  /**
   *
   * @return
   */
  render() {
    const {
      containerClassName, label, inputClassName, placeholder, value, maxlength, type, users, referenceValue, onChange, onBlur, disabled, required, showError, options, isHorizontalUi, labelClassName, width, height, name, inputErrorClassName, islineFields, showErrorCheckBox, ISTStartOfDay, ISTEndOfDay, isForGRNLine, isFromQC,
    } = this.props;
    const labelHtml = label && (
      <Tooltip title={label}>
        <label
          className={labelClassName || 'default-label'}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            maxWidth: 220,
          }}
        >
          <span
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '100%',
              display: 'inline-block',
            }}
          >
            {label}
          </span>
          {required && <span style={{ color: 'red', marginLeft: 4 }}>*</span>}
        </label>
      </Tooltip>
    );
    return (
      <React.Fragment>
        <div className={containerClassName}>
          {labelHtml}
          <div style={isHorizontalUi && { width: 'calc(100% - 180px)' }}>
            {type === 'TEXT' && (
              <div style={{ display: 'flex' }}>
                <Input
                  placeholder={placeholder}
                  value={value}
                  maxLength={maxlength}
                  onChange={(e) => onChange(e.target.value)}
                  className={`${type?.toUpperCase() !== 'CHECKBOX' ? showError ? inputErrorClassName : inputClassName : ''}`}
                  disabled={disabled}
                  onBlur={onBlur}
                  min="0"
                  status={(showError) ? 'error' : ''}
                  onWheel={(event) => event.target.blur()}
                />
                {referenceValue && (
                  <Input
                    value={referenceValue && `eg. ${referenceValue}`}
                    maxLength={maxlength}
                    onChange={(e) => onChange(e.target.value)}
                    className={`${type?.toUpperCase() !== 'CHECKBOX' ? inputClassName || 'default-input' : ''} ${showError ? inputErrorClassName : ''}`}
                    disabled
                    onBlur={onBlur}
                    style={{
                      color: 'rgb(86,143,246)',
                      backgroundColor: '#f1f6ff',
                      fontWeight: '600',
                    }}
                    min="0"
                    status={(showError) ? 'error' : ''}
                    onWheel={(event) => event.target.blur()}
                  />
                )}
              </div>
            )}
            {type === 'NUMBERS' && (
              <div style={{ display: 'flex' }}>
                <input
                  placeholder={placeholder}
                  value={value}
                  maxLength={maxlength}
                  type="number"
                  onChange={(e) => onChange(e.target.value)}
                  className={`${showError ? inputErrorClassName : inputClassName || 'default-input'}`}
                  disabled={disabled}
                  onBlur={onBlur}
                  min="0"
                  status={(showError) ? 'error' : ''}
                  onWheel={(event) => event.target.blur()}
                />
                {referenceValue && (
                  <Input
                    value={referenceValue && `eg. ${referenceValue}`}
                    maxLength={maxlength}
                    onChange={(e) => onChange(e.target.value)}
                    className={`${type?.toUpperCase() !== 'CHECKBOX' ? inputClassName || 'default-input' : ''} ${showError ? inputErrorClassName : ''}`}
                    disabled
                    onBlur={onBlur}
                    style={{
                      color: 'rgb(86,143,246)',
                      backgroundColor: '#f1f6ff',
                      fontWeight: '600',
                    }}
                    min="0"
                    status={(showError) ? 'error' : ''}
                    onWheel={(event) => event.target.blur()}
                  />
                )}
              </div>
            )}
            {type === 'DROPDOWN' && (
              <div style={referenceValue ? { display: 'flex' } : {}}>
                <div className={`${inputClassName?.replace('orgFormInput', '')?.replace(' ', '') || 'default-select'}`}>
                  <PRZSelect
                    value={value}
                    showSearch
                    // filterOption={false}
                    onChange={(selectedValue) => onChange(selectedValue)}
                    className={showErrorCheckBox ? 'prz-select__error-border' : ''}
                    style={{
                      height: height || '28px',
                      width: width || '100%', // Corrected line
                      fontSize: '13px',
                      backgroundColor: showErrorCheckBox ? 'rgba(238, 64, 76, 0)' : 'fefefe',
                      fontWeight: '600',
                    }}
                    placeholder={placeholder}
                    disabled={disabled}
                    status={(showError) ? 'error' : ''}
                    allowClear
                  >
                    {
                      options?.map((option) => <Option key={option} title={option} value={option}>{option}</Option>)
                    }

                  </PRZSelect>
                </div>
                {referenceValue && (
                  <input
                    value={referenceValue && `eg. ${referenceValue}`}
                    maxLength={maxlength}
                    onChange={(e) => onChange(e.target.value)}
                    className={`${type?.toUpperCase() !== 'CHECKBOX' ? inputClassName || 'default-input' : ''} ${showError ? inputErrorClassName : ''}`}
                    disabled
                    onBlur={onBlur}
                    style={{
                      color: 'rgb(86,143,246)',
                      backgroundColor: '#f1f6ff',
                      fontWeight: '600',
                    }}
                    min="0"
                    onWheel={(event) => event.target.blur()}
                  />
                )}
              </div>
            )}
            {type === 'ATTACHMENT' && (
              <div className={`attachment-parent ${showError ? (islineFields ? 'line__upload-error' : isFromQC ? 'upload-qc-field-error' : 'upload-error') : ''}`} style={{ display: 'flex' }}>
                <Upload
                  action={`${Constants.UPLOAD_FILE}`}
                  // listType="picture-card"
                  fileList={value}
                  disabled={disabled}
                  accept=".pdf,.jpg,.jpeg,.png,.xlsx,.xls"
                  beforeUpload={(file) => {
                    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
                    const isAllowedType = allowedTypes.includes(file.type);

                    if (!isAllowedType) {
                      notification.error({
                        message: 'You can only upload PDF, JPG, JPEG, PNG or XLSX files!',
                        placement: 'top',
                        duration: 4,
                      });
                    }

                    return isAllowedType;
                  }}
                  onChange={(fileListData) => {
                    const allowedExtensions = ['.pdf', '.jpg', '.jpeg', '.png', '.xlsx', '.xls'];
                    const filteredFiles = fileListData.fileList?.filter((item) => {
                      const fileExtension = item?.name?.substring(item.name.lastIndexOf('.')).toLowerCase();
                      return !item.error && allowedExtensions.includes(fileExtension);
                    });

                    onChange(filteredFiles);

                    if (fileListData?.file?.error) {
                      notification.error({
                        message: 'File upload failed. Please try again!',
                        placement: 'top',
                        duration: 4,
                      });
                    }
                  }}
                >
                  {value?.length >= (islineFields ? 1 : 5) ? null : (
                    <div
                      style={{
                        color: disabled ? '#666666' : '',
                        opacity: disabled ? 0.6 : 1,
                        pointerEvents: disabled ? 'none' : 'auto',
                        cursor: disabled ? 'not-allowed' : 'pointer',
                        // padding: '8px 16px',
                      }}
                    >
                      {isForGRNLine ? uploadButtonForGRNLine : uploadButton}
                    </div>
                  )}
                </Upload>
                {referenceValue && (
                  <input
                    value={referenceValue && `eg. ${referenceValue}`}
                    maxLength={maxlength}
                    onChange={(e) => onChange(e.target.value)}
                    className={`${type?.toUpperCase() !== 'CHECKBOX' ? inputClassName || 'default-input' : ''} ${showError ? inputErrorClassName : ''}`}
                    disabled
                    onBlur={onBlur}
                    style={{
                      color: 'rgb(86,143,246)',
                      backgroundColor: '#f1f6ff',
                      fontWeight: '600',
                    }}
                    min="0"
                    onWheel={(event) => event.target.blur()}
                  />
                )}
              </div>
            )}
            {type === 'TEXTAREA' && (
              <div style={{ display: 'flex' }}>
                <TextArea
                  placeholder={placeholder}
                  value={value}
                  maxLength={maxlength}
                  onChange={(e) => onChange(e.target.value)}
                  className={`${inputClassName || 'default-input'} ${showError ? inputErrorClassName : ''}`}
                  disabled={disabled}
                  onBlur={onBlur}
                  style={{
                    height: '100px',
                    width: referenceValue ? '50%' : '100%',
                  }}
                  min="0"
                  status={(showError) ? 'error' : ''}
                />
                {referenceValue && (
                  <Input
                    value={referenceValue && `eg. ${referenceValue}`}
                    maxLength={maxlength}
                    onChange={(e) => onChange(e.target.value)}
                    className={`${type?.toUpperCase() !== 'CHECKBOX' ? inputClassName || 'default-input' : ''} ${showError ? inputErrorClassName : ''}`}
                    disabled
                    onBlur={onBlur}
                    style={{
                      color: 'rgb(86,143,246)',
                      backgroundColor: '#f1f6ff',
                      fontWeight: '600',
                      height: '100px',
                    }}
                    min="0"
                    status={(showError) ? 'error' : ''}
                    onWheel={(event) => event.target.blur()}
                  />
                )}
              </div>
            )}
            {type === 'CHECKBOX' && (
              <div style={{ display: 'flex' }}>
                <Checkbox
                  checked={value}
                  onChange={() => onChange(!value)}
                  disabled={disabled}
                  onBlur={onBlur}
                  style={{ display: 'flex', marginTop: '3px' }}
                />
                {referenceValue && (
                  <Input
                    value={referenceValue && `eg. ${referenceValue}`}
                    maxLength={maxlength}
                    onChange={(e) => onChange(e.target.value)}
                    className={`${type?.toUpperCase() !== 'CHECKBOX' ? inputClassName || 'default-input' : ''} ${showError ? inputErrorClassName : ''}`}
                    disabled
                    onBlur={onBlur}
                    style={{
                      color: 'rgb(86,143,246)',
                      backgroundColor: '#f1f6ff',
                      fontWeight: '600',
                    }}
                    min="0"
                    status={(showError) ? 'error' : ''}
                    onWheel={(event) => event.target.blur()}
                  />
                )}
              </div>
            )}
            {type === 'DATE' && (
              <div style={{ display: 'flex' }}>
                <DatePicker
                  value={value && toISTDate(value, dateFormat)}
                  dateFormat
                  onChange={(selectedValue) => {
                    if (ISTStartOfDay) {
                      const setStartOfDay = (date) => {
                        if (!date) return null;
                        const newDate = new Date(date);
                        newDate.setHours(0, 0, 0, 0);
                        newDate.setMinutes(newDate.getMinutes() + 330);
                        return newDate;
                      };
                      const startOfDayValue = setStartOfDay(selectedValue);
                      onChange((startOfDayValue));
                    } else if (ISTEndOfDay) {
                      const setEndOfDay = (date) => {
                        if (!date) return null;
                        const newDate = new Date(date);
                        newDate.setHours(23, 59, 59, 999);
                        newDate.setMinutes(newDate.getMinutes() - 330);
                        return newDate;
                      };
                      const endOfDayValue = setEndOfDay(selectedValue);
                      onChange((endOfDayValue));
                    } else {
                      onChange(selectedValue);
                    }
                  }}
                  disabled={disabled}
                  className={`${inputClassName || 'default-input'} ${showError ? inputErrorClassName : ''}`}
                  format="DD-MM-YYYY"
                  style={{
                    backgroundColor: 'transparent',
                    width: '100%',
                  }}
                  status={(showError) ? 'error' : ''}
                />
                {referenceValue && (
                  <Input
                    value={referenceValue && `eg. ${referenceValue}`}
                    maxLength={maxlength}
                    onChange={(e) => onChange(e.target.value)}
                    className={`${type?.toUpperCase() !== 'CHECKBOX' ? inputClassName || 'default-input' : ''} ${showError ? inputErrorClassName : ''}`}
                    disabled
                    onBlur={onBlur}
                    style={{
                      color: 'rgb(86,143,246)',
                      backgroundColor: '#f1f6ff',
                      fontWeight: '600',
                    }}
                    min="0"
                    status={(showError) ? 'error' : ''}
                    onWheel={(event) => event.target.blur()}
                  />
                )}
              </div>
            )}
            {type === 'USERS' && (
              <div style={{ display: 'flex' }}>
                <div className={`${inputClassName?.replace('orgFormInput', '')?.replace(' ', '') || 'default-select'} ${showError ? inputErrorClassName : ''}`}>

                  <PRZSelect
                    value={value}
                    filterOption={false}
                    onChange={(selectedValue) => onChange(selectedValue)}
                    style={{
                      borderRadius: '2px',
                      height: '28px',
                      width: '100%',
                      fontSize: '13px',
                    }}
                    placeholder={placeholder}
                    disabled={disabled}
                    status={(showError) ? 'error' : ''}
                  >
                    {
                      users?.data[0]?.tenant_user?.map((user) => <Option key={user?.user_id} value={user?.user_id}>{`${user?.first_name?.toProperCase()} ${user?.last_name?.toProperCase()}`}</Option>)
                    }
                  </PRZSelect>
                </div>
                {referenceValue && (
                  <Input
                    value={referenceValue && `eg. ${referenceValue}`}
                    maxLength={maxlength}
                    onChange={(e) => onChange(e.target.value)}
                    className={`${type?.toUpperCase() !== 'CHECKBOX' ? inputClassName || 'default-input' : ''} ${showError ? inputErrorClassName : ''}`}
                    disabled
                    onBlur={onBlur}
                    style={{
                      color: 'rgb(86,143,246)',
                      backgroundColor: '#f1f6ff',
                      fontWeight: '600',
                    }}
                    min="0"
                    status={(showError) ? 'error' : ''}
                    onWheel={(event) => event.target.blur()}
                  />
                )}
              </div>
            )}

            {showError && !islineFields && (
              <div className="input-error">
                *Please enter
                {` ${label?.toLowerCase() || name?.toLowerCase()}`}
              </div>
            )}
          </div>
        </div>

      </React.Fragment>

    );
  }
}

const mapStateToProps = ({
  UserReducers, TenantReducers,
}) => ({
  user: UserReducers.user,
  users: TenantReducers.users,

});

const mapDispatchToProps = (dispatch) => ({

  getUsers: (tenantId, roleId) => dispatch(TenantActions.getUsers(tenantId, roleId)),

});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(H3CustomInput));
